const riot = require('riot');

riot.tag2('modal-calendar', '<div class="w472 bg-white border pt18 pb24 px16 rounded-8" ref="modal"> <div class="f fm fbw mb18"> <div class="fs16 bold">日付指定</div><i class="icon-close fs24 text-label_disabled cursor-pointer" onclick="{close}"></i> </div> <div class="mb24"> <div class="row"> <button class="h32 border border-label_dark_disabled fs11 px12 rounded-6 hover-trigger hover-bg-label_pale mr8" each="{item in buttonItems}" onclick="{onSelectEndDate}"> <div class="fs11">{item.label}</div> </button> </div> </div> <div class="f fm fbw mb5"> <button class="button label_pale f fh s20 p0" onclick="{onPrev}"><i class="icon-arrow-left fs16 cursor-pointer"></i></button> <div class="hover-trigger hover-opacity-60 transition fs13 lh15 bold cursor-pointer" if="{base}" onclick="{onSelectMonth}">{base.format(\'YYYY年 MM月\')}</div> <button class="button label_pale f fh s20 p0" onclick="{onNext}"><i class="icon-arrow-right fs16 cursor-pointer mrn3"></i></button> </div> <div class="row mb15" onmouseleave="{onMouseleaveRemove}"> <div class="px8 pt8 pb4 text-center border-bottom border-separator_opacity mb8" each="{week, index in weeks}" riot-style="width: {100/7}%"> <div class="f fh text-center fs10 text-{getTextColor(index)}">{week}</div> </div> <div class="relative f fh cursor-pointer p8 {getDateClass(date)} {date.isSame(this.opts.start_at || Date.now(),&quot;date&quot;)}" each="{date in dates}" riot-style="width: {100/7}%" onclick="{onSelectPeriod}" onmouseenter="{onMouseEnterDate}"> <div class="lh15 fs11 px8 px24 text-center">{date.date()}</div> <div class="absolute b5 w28 h2 bg-label_low rounded-full" if="{date.isSame(Date.now(),\'date\')}"></div> </div> </div> <div class="f fh"> <div class="button high w92 px0 fs12 mr16" onclick="{close}">キャンセル</div> <div class="button primary w92 px0 fs12" onclick="{onSave}">保存</div> </div> </div>', 'modal-calendar,[data-is="modal-calendar"]{ background-color: rgba(46, 46, 56, 0.7); }', 'class="f fh" spat-animation="push"', function(opts) {

    this.weeks = ["月", "火", "水", "木", "金", "土", "日"];

    var today = dayjs();
    var yesterday = today.subtract(1, 'day');
    var last_week = today.subtract(1, 'week');
    var last_month = today.subtract(1, 'month');
    var month_before_last = today.subtract(2, 'month');
    this.buttonItems = [
      { label: "今日", start_at: today.startOf('day'), end_at: today.endOf('day') },
      { label: "昨日", start_at: yesterday.startOf('day'), end_at: yesterday.endOf('day') },
      { label: "今週", start_at: today.startOf('week'), end_at: today.endOf('week') },
      { label: "先週", start_at: last_week.startOf('week'), end_at: last_week.endOf('week') },
      { label: "今月", start_at: today.startOf('month'), end_at: today.endOf('month') },
      { label: "先月", start_at: last_month.startOf('month'), end_at: last_month.endOf('month') },
      { label: "先々月", start_at: month_before_last.startOf('month'), end_at: month_before_last.endOf('month') },
    ];

    this.on('mount', () => {
      this.startAt = this.opts.start_at;
      this.endAt = this.opts.end_at;

      this.setup();
    });

    this.setup = (base) => {
      this.base = base || dayjs();

      const start = this.base.startOf('month');

      const end = this.base.endOf('month');

      this.dates = Array(end.date()).fill(0).map((v, i) => {

        return start.add(i, 'day');
      });

      var prev_month_date_num = ((start.day()+7)-1)%7;
      Array(prev_month_date_num).fill(0).forEach((v, i) => {
        this.dates.unshift(start.add(-(i+1), 'day'));
      });

      var next_month_date_num = 7 * 6 - this.dates.length;
      Array(next_month_date_num).fill(0).forEach((v, i) => {
        this.dates.push(end.add(i+1, 'day'));
      });
      this.update();
    };

    this.onPrev = () => {
      this.setup(this.base.add(-1, 'month'));
    };

    this.onNext = () => {
      this.setup(this.base.add(1, 'month'));
    };

    this.onSave = async () => {

      if(this.startAt && !this.endAt) {
        this.endAt = this.startAt;
      }
      this.trigger('submit', {
        start_at: this.startAt,
        end_at: this.endAt,
      });
      this.close();
    };

    this.onSelectEndDate = (e) => {
      var item = e.item.item;
      this.startAt = item.start_at;
      this.endAt = item.end_at;

      this.trigger('submit', {
        start_at: this.startAt,
        end_at: this.endAt,
      });
      this.close();
    };

    this.onSelectMonth = () => {
      this.startAt = this.base.startOf('month');
      this.endAt = this.base.endOf('month');

      this.trigger('submit', {
        start_at: this.startAt,
        end_at: this.endAt,
      });
      this.close();
    };

    this.getTextColor = (i) => {
      const SATURDAY = 5;
      const SUNDAY = 6;
      if (i === SUNDAY) {
        return 'alert_primary';
      }
      else if (i === SATURDAY) {
        return 'label_blue';
      }
      else {
        return 'label_dark_medium';
      }
    };

    this.onSelectPeriod = (e) => {

      var time = e.item.date;

      if(!this.startAt) {
        this.startAt = time;
        return;
      }

      if(this.endAt) {

        if(e.item.date.isBefore(this.endAt, "date")) {
          this.startAt = time;
          this.endAt = null;
          return ;
        }
      }

      if (e.item.date.isAfter(this.startAt)) {
        this.endAt = time;
      }
      else {
        this.startAt = time;
      }
    };

    this.isBetween = (date) => {

      return date.isAfter(this.startAt, "date") && date.isBefore(this.endAt, "date");
    };

    this.getDateClass = (date) => {

      if(this.startAt){

        if(date.isSame(this.startAt, "date")){
          return "text-white bg-primary rounded-top-left-4 rounded-bottom-left-4";
        }

        if(this.endAt) {

          if(date.isSame(this.endAt, "date")){
            return "text-white bg-primary rounded-top-right-4 rounded-bottom-right-4";
          }

          if(this.isBetween(date)) {
            return "bg-primary_pale";
          }
        }

        if(this.hoverDate) {

          if(this.hoverDate.isSame(date,"date") || date.isAfter(this.startAt,"date") && this.hoverDate.isAfter(date,"date")) {
            return "bg-primary_pale";
          }
        }
      }

      if(!date.isSame(this.base, "month")) {
        return "text-label_disabled";
      }
    };

    this.onMouseEnterDate = (e) => {
      this.hoverDate = e.item.date;
    };

    this.onMouseleaveRemove = () => {
      this.hoverDate = null;
    };
});